import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import AuthService from 'shared/services/auth.service';
import en from './translation/en';
import de from './translation/de';
import LanguageDetector from 'i18next-browser-languagedetector';

// the translations
// (tip move them in a JSON file and import them)
const resources = {
	en: {
		translation: en
	},
	de: {
		translation: de
	}
};

export enum Languages {
	DE = 'de',
	EN = 'en'
}

i18n.use(LanguageDetector)
	.use(initReactI18next as any) // passes i18n down to react-i18next
	.init({
		resources,
		lng: AuthService.getUserLanguage(),
		keySeparator: false, // we do not use keys in form messages.welcome
		interpolation: {
			escapeValue: false
		},
		detection: {
			order: ['localStorage', 'navigator'], // check localStorage first, then browser
			caches: ['localStorage'] // cache the selected language in localStorage
		}
	});

export default i18n;
const refreshLanguage = (language: string) => {
	i18n.changeLanguage(language);
	localStorage.setItem('lang', language);
	window.location.reload();
};
export { refreshLanguage };
